import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FieldType } from '@ngx-formly/material';
import { MatInput } from '@angular/material/input';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { ReplaySubject } from 'rxjs';
import { FormControl } from '@angular/forms';
import { FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'app-autocomplete-type',
  templateUrl: 'autocomplete-type.component.html'
})
export class AutocompleteTypeComponent extends FieldType<FieldTypeConfig> implements OnInit, AfterViewInit {
  @ViewChild(MatInput) formFieldControl!: MatInput;
  @ViewChild(MatAutocompleteTrigger) autocomplete!: MatAutocompleteTrigger;

  filteredOptions: ReplaySubject<any> = new ReplaySubject<any>(0);
  optionsForAutocomplete: any[] = [];

  public fControl!: FormControl;

  private isFirstTime = true;

  constructor(
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.fControl = this.formControl as FormControl;
    this.fControl?.valueChanges.subscribe((response) => {
      if (
        this.isFirstTime &&
        this.fControl.pristine &&
        response &&
        this.optionsForAutocomplete.length === 0 &&
        this.to['getByID'] !== undefined
      ) {
        this.isFirstTime = false;
        this.to['getByID'](response).subscribe((data: any) => {
          this.optionsForAutocomplete = [ data ];
          this.findDataInOptions(response);
        });
      }
    });
  }

  ngAfterViewInit(): void {
    // temporary fix for https://github.com/angular/material2/issues/6728
    (this.autocomplete as any)._formField = this.formField;
  }

  displayFn(value: any): void {
    const element = this.optionsForAutocomplete.find(
      (f) => f[this.to.valueProp] === value
    );
    if (this.to['optionLabel'] !== undefined && element !== undefined) {
      this.to['optionLabel'] = element[this.key.toString()];
    }
    return element ? element[this.to.labelProp] : value;
  }

  onChanges($event: Event): void {
    if (
      this.fControl.value !== undefined &&
      this.fControl.value !== null &&
      this.fControl.value.length >= 3
    ) {
      this.to['getByQuery']($event).subscribe((data: any) => {
        if (this.to['concatLabelWithValue'] === true) {
          data.forEach((item: any) => {
            item[this.to.labelProp] =
              item[this.to.labelProp.split('&')[0]] +
              ' ' +
              item[this.to.labelProp.split('&')[1]];
          });
        }
        this.optionsForAutocomplete = data;
        this.filteredOptions.next(this.optionsForAutocomplete);
      });
    }
  }

  private findDataInOptions(response: any): void {
    this.filteredOptions.next(
      this.optionsForAutocomplete.filter((item) => item[this.to.valueProp] === response)
    );
    this.autocomplete.writeValue(this.fControl.value);
    this.cdr.detectChanges();
  }
}
